import { dashboardRequest } from "../providers/aws/client";
import type { ProviderEcho, ProviderMetrics } from "./providerExperimentTypes";

export const H3_EXPERIMENT_ID = "h3-local-2026-09";
export type ProviderFilters = {
  since: string;
  until: string;
  scope: string;
  variant: string;
};
export type ProviderPage = {
  data: ProviderEcho[];
  next_cursor?: string | null;
  has_more: boolean;
};
export type ProviderSummary = {
  variants: ProviderMetrics[];
  environment: string;
  truncated: boolean;
};

export function fetchProviderEchoes(
  filters: ProviderFilters,
  cursor?: string,
  signal?: AbortSignal,
) {
  const params = new URLSearchParams({
    ...filters,
    limit: "50",
    ...(cursor ? { cursor } : {}),
  });
  const path =
    filters.scope === "customer"
      ? `/experiments/${H3_EXPERIMENT_ID}/echoes`
      : "/i2v/providers/h3_comfy/echoes";
  return dashboardRequest<ProviderPage>(`${path}?${params}`, { signal });
}

export async function fetchProviderSummary(
  filters: ProviderFilters,
  signal?: AbortSignal,
) {
  const result = await dashboardRequest<{ data: ProviderSummary }>(
    `/experiments/${H3_EXPERIMENT_ID}/provider-summary?${new URLSearchParams(filters)}`,
    { signal },
  );
  return result.data;
}
